import React from 'react';
import PropTypes from 'prop-types';

import * as styles from './styles.css';

export default function Footer({ children }) {
  if (!children) {
    return null;
  }

  return (
    <div className={`pull-right ${styles.footerControls}`}>
      {children}
    </div>
  );
}

Footer.propTypes = {
  children: PropTypes.node.isRequired,
};
